// extracted by mini-css-extract-plugin
export default {"root":"CommissionForm_root__7MBzq","form":"CommissionForm_form__wcvfU","body":"CommissionForm_body__J3f1f","footer":"CommissionForm_footer__cqoUr"};